import { deleteServiceHistory } from "../../../store/slices/vehicleSlice";

export default function responseDeleteServiceHistory(response: any, api: any, arg: any) {
    console.log('delete service history response', response);
    if (response?.data) {
        api.dispatch(deleteServiceHistory({
            id: arg.arguments?.vehicleId,
            serviceId: arg.arguments?.serviceId
        }));
    }
    return response?.data || null;
}